import { posthog } from "posthog-js";
interface IEnv {
  [key: string]: string | undefined;
}

export class Config {
  #DEFAULT_CONTENT_ENGINE: string;
  #DEFAULT_REPORT_SERVER: string;
  #DEFAULT_AUTH_SERVER: string;
  #DEFAULT_TEMPLATE_SERVER: string;
  #DEFAULT_AUTH_DOMAIN: string;
  #AUTO_GENERATED_URI: string;
  #SEMANTIC_AXIS_URI: string;
  #DOCUMENT_SECTIONS_URI: string;
  #PATIENT_ID_URI: string;
  #ENCOUNTER_ID_URI: string;
  #defaultLanguage: string; // Where do we use this?

  env = {} as IEnv;
  constructor(env: IEnv) {
    this.env = env;
    this.checkConfig();
    this.#defaultLanguage = "nl";
    this.#AUTO_GENERATED_URI =
      "http://tiro.health/fhir/CodeSystem/auto-generated";
    this.#SEMANTIC_AXIS_URI =
      "http://tiro.health/fhir/CodeSystem/semantic-axis";
    this.#DOCUMENT_SECTIONS_URI =
      "http://tiro.health/fhir/CodeSystem/document-sections";
    this.#PATIENT_ID_URI = "http://tiro.health/fhir/NamingSystem/patient-id";
    this.#ENCOUNTER_ID_URI =
      "http://tiro.health/fhir/NamingSystem/encounter-id";
    this.#DEFAULT_CONTENT_ENGINE =
      env.REACT_APP_CONTENT_ENGINE ??
      (this.ENV == "staging" || this.ENV == "development"
        ? "https://content-staging.tiro.health"
        : "https://content.tiro.health");
    this.#DEFAULT_REPORT_SERVER =
      env.REACT_APP_REPORT_SERVER ??
      (this.ENV == "staging" || this.ENV == "development"
        ? "https://reports-staging.tiro.health"
        : "https://reports.tiro.health");
    this.#DEFAULT_AUTH_SERVER =
      env.REACT_APP_AUTH_SERVER ??
      (this.ENV == "staging" || this.ENV == "development"
        ? "https://auth-staging.tiro.health"
        : "https://auth.tiro.health");
    this.#DEFAULT_TEMPLATE_SERVER =
      env.REACT_APP_TEMPLATE_SERVER ??
      (this.ENV == "staging" || this.ENV == "development"
        ? "https://template-staging.tiro.health"
        : "https://templates.tiro.health");
    this.#DEFAULT_AUTH_DOMAIN =
      this.ENV == "development"
        ? "staging.tiro.health"
        : window.location.hostname;
  }
  checkConfig() {
    if (!window) {
      console.debug("window is not defined");
      return;
    }
    if (!window.APM_ENV) {
      console.debug("APM_ENV is not set");
    }
    if (!window.APP_ENV) {
      console.debug("APP_ENV is not set");
    }
    if (!!window.APP_ENV && !!window.APM_ENV) {
      console.debug("Environment config loaded.");
    }
  }
  get REDIRECT() {
    return this.env.REACT_APP_REDIRECT ?? window.REDIRECT ?? "/patients";
  }
  get ENV() {
    if (window.location.hostname.includes("ngrok")) return "development";
    if (window.location.hostname.includes("local")) return "development";
    if (window.location.hostname.includes("storybook")) return "staging";
    return this.env.REACT_APP_ENV ?? window.APP_ENV ?? "production";
  }
  get CONTENT_ENGINE() {
    return this.#DEFAULT_CONTENT_ENGINE;
  }
  get REPORT_SERVER() {
    return this.#DEFAULT_REPORT_SERVER;
  }
  get TEMPLATE_SERVER() {
    return this.#DEFAULT_TEMPLATE_SERVER;
  }
  get AUTH_SERVER() {
    return this.#DEFAULT_AUTH_SERVER;
  }
  get AUTH_DOMAIN() {
    return this.#DEFAULT_AUTH_DOMAIN;
  }
  get AUTO_GENERATED_URI() {
    return this.#AUTO_GENERATED_URI;
  }
  get SEMANTIC_AXIS_URI() {
    return this.#SEMANTIC_AXIS_URI;
  }
  get DOCUMENT_SECTIONS_URI() {
    return this.#DOCUMENT_SECTIONS_URI;
  }
  get PATIENT_ID_URI() {
    return this.#PATIENT_ID_URI;
  }
  get ENCOUNTER_ID_URI() {
    return this.#ENCOUNTER_ID_URI;
  }

  get TOKEN_EXCHANGE() {
    return new URL("auth/token", this.CONTENT_ENGINE);
  }
  get isDev() {
    if (window.location.hostname === "localhost") return true;
    if (window.location.hostname === "write.tiro.local") return true;
    return window.APP_ENV === "development";
  }
  get isStaging() {
    return window.APP_ENV === "staging";
  }

  get isDemo() {
    const url = new URL(window.location.href);
    const demo = url.searchParams.get("demo");
    return window.location.hostname === "demo.tiro.health" || demo === "true";
  }
  get version() {
    return this.env.REACT_APP_VERSION;
  }

  get fhirURL() {
    return this.REPORT_SERVER + "/fhir/r5/";
  }

  get withReportServer() {
    return false;
  }
}

export const CONFIG = new Config(import.meta.env);
